import React, { useState, useEffect } from 'react';
import './feedbackChatbot.css';

const messages = [
  "Un avis à donner ?",
  "Une question ?",
  "Une demande ?"
];

const FeedbackChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [step, setStep] = useState(0);
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [honeypot, setHoneypot] = useState('');
  const [cooldown, setCooldown] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipText, setTooltipText] = useState(messages[0]);

  const COOLDOWN_TIME = 20;

  useEffect(() => {
    const last = localStorage.getItem('fcb-last-send');
    if (last && Date.now() - parseInt(last) < COOLDOWN_TIME * 1000) {
      setCooldown(true);
    }
  }, []);

  // Affichage aléatoire de message tooltip toutes les 45s
  useEffect(() => {
    if (!isOpen) {
      const interval = setInterval(() => {
        const random = messages[Math.floor(Math.random() * messages.length)];
        setTooltipText(random);
        setTooltipVisible(true);
        setTimeout(() => setTooltipVisible(false), 4000);
      }, 45000);
      return () => clearInterval(interval);
    }
  }, [isOpen]);

  const handleSend = async () => {
    if (honeypot !== '') return;

    const blacklist = ['merde', 'con', 'putain', 'fuck', 'shit'];
    const containsBadWords = blacklist.some(word => message.toLowerCase().includes(word));
    if (containsBadWords) {
      alert('Ton message contient des mots inappropriés.');
      return;
    }

    if (cooldown) {
      alert(`Merci d’attendre quelques secondes avant d’envoyer un nouveau message.`);
      return;
    }

    const data = {
      type,
      message,
      email,
      page: window.location.pathname,
    };

    try {
      await fetch('https://script.google.com/macros/s/AKfycbwEwNOKIEZrIe7svNLo64rE1-Af0x93MQw-8SHa6q49U76FrZE2fj8RljefBfWrbpnh/exec', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });

      localStorage.setItem('fcb-last-send', Date.now().toString());
      setCooldown(true);
      setStep(3);
    } catch (err) {
      console.error('Erreur envoi', err);
      alert("Erreur lors de l'envoi du message.");
    }
  };

  const renderBubble = (text, sender = 'bot') => (
    <div className={`fcb-chat-bubble fcb-${sender}`}>
      <span>{text}</span>
    </div>
  );

  const renderContent = () => {
    switch (step) {
      case 0:
        return (
          <div className="fcb-chat">
            {renderBubble("Comment puis-je t’aider ?")}
            <div className="fcb-btn-group">
              <button onClick={() => { setType('Avis'); setStep(1); }}>Donner un avis</button>
              <button onClick={() => { setType('Question'); setStep(1); }}>Poser une question</button>
              <button onClick={() => { setType('Idée'); setStep(1); }}>Proposer une idée</button>
              <button onClick={() => { setType('Problème'); setStep(1); }}>Signaler un bug</button>
            </div>
          </div>
        );
      case 1:
        return (
          <div className="fcb-chat">
            {renderBubble("Merci ! Écrivez votre message :")}
            <textarea value={message} onChange={e => setMessage(e.target.value)} />
            <div className="fcb-btn-row">
              <button onClick={() => setStep(2)}>Suivant</button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="fcb-chat">
            {renderBubble("Souhaites-tu être recontacté ? (facultatif)")}
            <input type="email" placeholder="Ton e-mail (optionnel)" value={email} onChange={e => setEmail(e.target.value)} />
            <input type="text" style={{ display: 'none' }} value={honeypot} onChange={e => setHoneypot(e.target.value)} />
            <div className="fcb-btn-row">
              <button onClick={handleSend}>Envoyer</button>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="fcb-chat">
            {renderBubble("✅ Merci ! Ton message a bien été envoyé.", 'user')}
            <div className="fcb-btn-row">
              <button onClick={() => { setIsOpen(false); setStep(0); setMessage(''); setEmail(''); }}>Fermer</button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      {!isOpen && tooltipVisible && (
        <div className="fcb-tooltip">
          {tooltipText}
        </div>
      )}

      <div
        className="fcb-bubble-icon"
        onClick={() => setIsOpen(!isOpen)}
        onMouseEnter={() => {
          setTooltipText(messages[Math.floor(Math.random() * messages.length)]);
          setTooltipVisible(true);
        }}
        onMouseLeave={() => setTooltipVisible(false)}
      >
        💬
      </div>

      <div className={`fcb-window-wrapper ${isOpen ? 'open' : ''}`}>
        <div className="fcb-window">
          <div className="fcb-header">
            Contact rapide
            <span className="fcb-close-btn" onClick={() => setIsOpen(false)}>✖</span>
          </div>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

export default FeedbackChatbot;
